<template>
    <!-- component -->
    <div class="leading-loose">
        <form @submit.prevent="submit" class="md:w-2/3 mx-auto p-10 bg-white rounded shadow-xl">
            <h2 class="uppercase text-2xl font-bold text-center">{{ __('donnees') }}</h2>
            <p v-if="$page?.props?.flash?.succes" class="text-center py-4 text-green-500 text-sm font-semibold">
                {{ __($page?.props?.flash?.succes) }}
            </p>
            <p v-if="$page?.props?.flash?.echec" class="text-center py-4 text-green-500 text-sm font-semibold">
                {{ __($page?.props?.flash?.echec) }}
            </p>
            <div class="mt-4">
                <label class="text-sm block text-cavilam-primary font-semibold">{{ __('Civilite') }} <sup class="text-red-500">*</sup></label>
                <div class="flex flex-row">
                    <label for="madame" class="cursor-pointer inline-flex items-center mx-2">
                        <input v-model="form.civilite" value="madame" type="radio" name="civilite" id="madame" class="cursor-pointer h-5 w-5 text-cavilam-primary border-cavilam-primary" required><span class="ml-2 text-gray-700">{{ __('Madame') }}</span>
                    </label>
                    <label for="monsieur" class="cursor-pointer inline-flex items-center mx-2">
                        <input v-model="form.civilite" value="monsieur" type="radio" name="civilite" id="monsieur" class="cursor-pointer h-5 w-5 text-cavilam-primary border-cavilam-primary" required><span class="ml-2 text-gray-700">{{ __('Monsieur') }}</span>
                    </label>
                    <label for="autre" class="cursor-pointer inline-flex items-center mx-2">
                        <input v-model="form.civilite" value="autre" type="radio" name="civilite" id="autre" class="cursor-pointer h-5 w-5 text-cavilam-primary border-cavilam-primary" required><span class="ml-2 text-gray-700">{{ __('Autre') }}</span>
                    </label>
                </div>
                <p class="text-red-500 text-xs" :class="{'invisible':!form.errors.civilite}">{{ __(form.errors.civilite) }}</p>
            </div>
            <div class="inline-block mt-4 w-full md:w-1/2 md:pr-2">
                <input-form libelle="Prenom" name="prenom" :required="true"></input-form>
            </div>
            <div class="inline-block mt-4 w-full md:w-1/2">
                <input-form libelle="Nom" name="nom" :required="true"></input-form>
            </div>
            <div class="inline-block mt-4 w-full md:w-1/2 md:pr-2">
                <nationality-selector :liste="nationalites" :required="true"></nationality-selector>
            </div>
            <div class="inline-block mt-4 w-full md:w-1/2">
                <label class="text-sm block text-cavilam-primary font-semibold" for="date_naissance">{{ __('date_naissance') }} <sup class="text-red-500">*</sup></label>
                <input v-model="form.date_naissance"
                       placeholder="YYYY-MM-DD"
                       min="1900-01-01"
                       :max="new Date().toISOString().split('T')[0]"
                       :class="{'border-red-500':form.errors.date_naissance}"
                       class="cursor-pointer w-full px-2 py-2 text-gray-700 rounded border-cavilam-primary"
                       id="date_naissance" name="date_naissance" type="date" required
                       pattern="[0-9]{4}-[0-9]{2}-[0-9]{2}">
                <p class="text-red-500 text-xs" :class="{'invisible':!form.errors.date_naissance}">{{ __(form.errors.date_naissance) }}</p>
            </div>
            <div class="inline-block mt-4 w-full md:w-1/2 md:pr-2">
                <input-form libelle="Email" name="email" type="email" :readonly="!!(utilisateur && utilisateur.email)" :required="true"></input-form>
            </div>
            <div class="inline-block mt-4 w-full md:w-1/2">
                <profession-selector :liste="professions" :required="false"></profession-selector>
            </div>
            <div class="mt-4">
                <input-form libelle="Adresse" name="adresse" :required="true"></input-form>
            </div>
            <div class="inline-block mt-4 w-full md:w-1/2 md:pr-2">
                <input-form libelle="Ville" name="ville" :required="true"></input-form>
            </div>
            <div class="inline-block mt-4 w-full md:w-1/2">
                <input-form libelle="Code_postal" name="code_postal" :required="true"></input-form>
            </div>
            <div class="mt-4">
                <pays-selector :libelle="'Pays'" :name="'pays'" :liste="pays" :required="true"></pays-selector>
            </div>
            <div class="mt-4">
                <label class="inline-flex items-center mt-3">
                    <input @click="resetFacturation" v-model="form.adresse_facturation_differente" name="adresse_facturation_differente" type="checkbox" class="cursor-pointer h-5 w-5 text-cavilam-primary border-cavilam-primary"><span class="ml-2 text-gray-700">{{ __('cocher_pour_renseigner_une_adresse_de_facturation_differente') }}</span>
                </label>
            </div>
            <div v-if="form.adresse_facturation_differente">
                <div class="mt-4">
                    <input-form libelle="Adresse_facturation" name="adresse_facturation" :required="true"></input-form>
                </div>
                <div class="inline-block mt-2 w-full md:w-1/2 md:pr-2">
                    <input-form libelle="Ville_facturation" name="ville_facturation" :required="true"></input-form>
                </div>
                <div class="inline-block mt-2 w-full md:w-1/2">
                    <input-form libelle="Code_postal_facturation" name="code_postal_facturation" :required="true"></input-form>
                </div>
                <div class="mt-2 mb-4">
                    <pays-selector :libelle="'Pays_facturation'" :name="'pays_facturation'" :liste="pays" :required="true"></pays-selector>
                </div>
            </div>
            <div class="inline-block mt-4 w-full md:w-1/2 md:pr-2">
                <input-form libelle="Ville_naissance" name="ville_naissance" :required="true"></input-form>
            </div>
            <div class="inline-block mt-4 w-full md:w-1/2">
                <langue-selector :libelle="'langue_maternelle'" :name="'langue_maternelle'" :required="true"></langue-selector>
            </div>
            <div class="mt-4">
                <pays-selector :libelle="'Pays_naissance'" :name="'pays_naissance'" :liste="pays" :required="true"></pays-selector>
            </div>
            <div class="inline-block mt-4 w-full md:w-1/2 md:pr-2">
                <input-form libelle="Mobile" name="mobile" :required="true"></input-form>
            </div>
            <div class="inline-block mt-4 w-full md:w-1/2">
                <input-form libelle="Telephone" name="telephone" :required="false"></input-form>
            </div>
            <div class="mt-4">
                <label class="text-sm block text-cavilam-primary font-semibold">{{ __('etes_vous_deja_venu_au_cavilam') }}</label>
                <div class="flex flex-row">
                    <label class="inline-flex items-center mx-2 cursor-pointer">
                        <input v-model="form.est_deja_client" type="radio" name="est_deja_client" :value="true" id="oui" class="cursor-pointer h-5 w-5 text-cavilam-primary border-cavilam-primary" required><span for="oui" class="ml-2 text-gray-700">Oui</span>
                    </label>
                    <label class="inline-flex items-center mx-2 cursor-pointer">
                        <input v-model="form.est_deja_client" type="radio" name="est_deja_client" :value="false" id="non" class="cursor-pointer h-5 w-5 text-cavilam-primary border-cavilam-primary" required><span for="non" class="ml-2 text-gray-700">Non</span>
                    </label>
                </div>
                <p class="text-red-500 text-xs" :class="{'invisible':!form.errors.est_deja_client}">{{ __(form.errors.est_deja_client) }}</p>
            </div>
            <div v-if="form.est_deja_client" class="inline-block mt-4 w-full md:w-1/2 md:pr-2">
                <input-form libelle="En_quelle_annee" name="annee_venue" :required="true"></input-form>
            </div>

            <div class="inline-block mt-4 w-full md:w-1/2">
                <input-form libelle="Numero_candidat" name="numero_candidat" :required="false"></input-form>
            </div>
            <div class="mt-4">
                <p class="text-base block text-cavilam-primary font-semibold">{{ __('piece_jointe_description') }}</p>
                <div class="flex flex-col lg:flex-row justify-evenly">
                    <div class="mt-4 w-full md:w-64 text-center">
                        <label class="w-64 m-auto flex flex-col items-center px-4 py-6 bg-white text-cavilam-primary rounded-md shadow-sm tracking-wide uppercase border border-cavilam-primary cursor-pointer hover:bg-cavilam-primary hover:text-gray-100">
                            <svg class="w-8 h-8" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                                <path d="M16.88 9.1A4 4 0 0 1 16 17H5a5 5 0 0 1-1-9.9V7a3 3 0 0 1 4.52-2.59A4.98 4.98 0 0 1 17 8c0 .38-.04.74-.12 1.1zM11 11h3l-4-4-4 4h3v3h2v-3z" />
                            </svg>
                            <span class="mt-2 text-base leading-normal">{{ __('piece_jointe_1') }}</span>
                            <input @input="form.pj = $event.target.files[0]" type='file' accept=".jpg, .png, .pdf" name="pj" class="opacity-0" />
                        </label>
                        <p class="text-red-500 text-xs" :class="{'invisible':!form.errors.pj}">{{ __(form.errors.pj) }}</p>
                        <a v-if="utilisateur.pj"
                              as="button"
                              target="_blank"
                              :href="route('utilisateur.download.pj', {'type': 'pj'})"
                              class="relative w-fit h-fit text-sm border-b text-cavilam-primary border-cavilam-primary">
                            Télécharger
                        </a>
                    </div>
                    <div class="mt-4 w-full md:w-64 text-center">
                        <label class="w-64 m-auto flex flex-col items-center px-4 py-6 bg-white text-cavilam-primary rounded-md shadow-sm tracking-wide uppercase border border-cavilam-primary cursor-pointer hover:bg-cavilam-primary hover:text-gray-100">
                            <svg class="w-8 h-8" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                                <path d="M16.88 9.1A4 4 0 0 1 16 17H5a5 5 0 0 1-1-9.9V7a3 3 0 0 1 4.52-2.59A4.98 4.98 0 0 1 17 8c0 .38-.04.74-.12 1.1zM11 11h3l-4-4-4 4h3v3h2v-3z" />
                            </svg>
                            <span class="mt-2 text-base leading-normal">{{ __('piece_jointe_2') }}</span>
                            <input @input="form.pj_facultative = $event.target.files[0]" type='file' accept=".jpg, .png, .pdf" name="pj_facultative" class="opacity-0" />
                        </label>
                        <p class="text-red-500 text-xs" :class="{'invisible':!form.errors.pj_facultative}">{{ __(form.errors.pj_facultative) }}</p>
                        <a v-if="utilisateur.pj_facultative"
                              as="button"
                              target="_blank"
                              :href="route('utilisateur.download.pj', {'type': 'pj_facultative'})"
                              class="relative w-fit h-fit text-sm border-b text-cavilam-primary border-cavilam-primary">
                            Télécharger
                        </a>
                    </div>
                </div>
            </div>

            <div class="mt-2">
                <label for="newsletter" class="inline-flex items-center mt-3">
                    <input v-model="form.newsletter" :class="{'border-red-500':form.errors.newsletter}" name="newsletter" type="checkbox" id="newsletter" class="cursor-pointer h-5 w-5 text-cavilam-primary border-cavilam-primary"><span class="ml-2 text-gray-700">{{ __('acceptation_newsleter') }}</span>
                </label>
                <p class="text-red-500 text-xs" :class="{'invisible':!form.errors.newsletter}">{{ __(form.errors.newsletter) }}</p>
            </div>
            <div class="m-4 text-center">
                <breeze-button
                    :class="{ 'opacity-25': form.processing }"
                    :disabled="form.processing">
                    {{ __('envoyer') }}
                </breeze-button>
            </div>
            <div>
                <p class="text-sm text-gray-400 text-right">
                    <sup class="text-red-500">*</sup> {{ __('les_champs_marques_sont_obligatoires') }}
                </p>
            </div>
        </form>
    </div>
</template>

<script>
import App from "@/Layouts/App";
import PaysSelector from "@/Components/PaysSelector";
import BreezeButton from "@/Components/Button";
import NationalitySelector from "@/Components/NationalitySelector";
import ProfessionSelector from "@/Components/ProfessionSelector";
import LangueSelector from "@/Components/LangueSelector";
import InputForm from "@/Components/InputForm";

export default {
    layout: App,
    name: "EditionDonnees",
    components: {
        PaysSelector,
        BreezeButton,
        NationalitySelector,
        ProfessionSelector,
        LangueSelector,
        InputForm
    },
    props: {
        utilisateur: Object,
        contientExamen: Boolean,
        pays: Array,
        nationalites: Array,
        professions: Array,
    },
    data() {
        return {
            form: this.$inertia.form({
                civilite: this.utilisateur.civilite,
                prenom: this.utilisateur.prenom,
                nom: this.utilisateur.nom,
                nationalite: this.utilisateur.nationalite,
                date_naissance: this.utilisateur.date_naissance,
                email: this.utilisateur.email,
                profession: this.utilisateur.profession,
                adresse: this.utilisateur.adresse,
                ville: this.utilisateur.ville,
                code_postal: this.utilisateur.code_postal,
                pays: this.utilisateur.pays,
                adresse_facturation_differente: !!(this.utilisateur.adresse_facturation),
                adresse_facturation: this.utilisateur.adresse_facturation,
                ville_facturation: this.utilisateur.ville_facturation,
                code_postal_facturation: this.utilisateur.code_postal_facturation,
                pays_facturation: this.utilisateur.pays_facturation,
                langue_maternelle: this.utilisateur.langue_maternelle,
                ville_naissance: this.utilisateur.ville_naissance,
                pays_naissance: this.utilisateur.pays_naissance,
                mobile: this.utilisateur.mobile,
                telephone: this.utilisateur.telephone,
                est_deja_client: !!(this.utilisateur.est_deja_client),
                newsletter: !!(this.utilisateur.newsletter),
                annee_venue: this.utilisateur.annee_venue,
                pj: null,
                pj_facultative: null,
                numero_candidat: this.utilisateur.numero_candidat,
            }),
        }
    },
    methods: {
        resetFacturation(e) {
            if(!e.target.checked) {
                this.form.adresse_facturation = '';
                this.form.ville_facturation = '';
                this.form.code_postal_facturation = '';
                this.form.pays_facturation = '';
            }
        },
        submit() {
            this.form.post(this.route('utilisateur.enregistrer.donnees'), this.form);
        },
    }
}
</script>

<style scoped>

</style>
